import { TypedMessages } from '@nxsys/hooks/useTypedIntl';
import { EXPORT_STATUS, ExportStatus } from '@nxsys/store/slices/export/types';
import { Icons } from '@nxsys/types/icons';
import { Tag, Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';

export const getColumns = ({
  messages,
}: {
  messages: TypedMessages;
}): ColumnsType<any> => {
  return [
    {
      key: 'action',
      title: messages['common.action'],
      fixed: 'left',
      align: 'left',
      // NX-5603: an export has no file until it has completed.
      render: (record) =>
        record?.status === EXPORT_STATUS.COMPLETED && record?.linkFile ? (
          <ul>
            <li onClick={() => window.open(record?.linkFile, '_blank')}>
              <Tooltip title="Download">
                <span><Icons.IconDownload /></span>
              </Tooltip>
            </li>
          </ul>
        ) : null,
      width: 100,
    },
    {
      key: 'fileName',
      title: messages['export.company.fileName'],
      dataIndex: 'fileName',
      width: 400,
    },
    {
      key: 'status',
      title: messages['export.company.status'],
      dataIndex: 'status',
      width: 140,
      render: (status: ExportStatus) => {
        const tag = {
          [EXPORT_STATUS.IN_PROGRESS]: {
            color: 'processing',
            label: messages['export.company.inProgress'],
          },
          [EXPORT_STATUS.COMPLETED]: {
            color: 'success',
            label: messages['common.completed'],
          },
          [EXPORT_STATUS.FAILED]: {
            color: 'error',
            label: messages['common.failed'],
          },
        }[status];
        return tag ? <Tag color={tag.color}>{tag.label}</Tag> : null;
      },
    },
    {
      key: 'companies',
      title: messages['export.company.companiesName'],
      dataIndex: 'companies',
      render: (record) =>
        record?.map((item: any) => item?.companyName)?.join(', '),
    },
    {
      key: 'exportOn',
      title: messages['export.company.exportOn'],
      dataIndex: 'exportOn',
      render: (record) =>
        record ? moment(record).format('DD/MM/YYYY HH:mm') : '',
    },
    {
      key: 'exportBy',
      title: messages['export.company.exportBy'],
      dataIndex: 'exportBy',
      render: (record) => `${record?.forename ?? ''} ${record?.surname ?? ''}`,
    },
  ];
};
